import React from 'react';
import { useTheme } from 'contexts/ThemeContext';
import { Shield, Menu } from 'lucide-react';
import { useSidebar } from 'contexts/SidebarContext';
import ProxiesManager from 'components/dashboard/ProxiesManager';

const ProxiesManagement: React.FC = () => {
  const { isDark } = useTheme();
  const { toggleSidebar } = useSidebar();

  const containerBg = isDark ? '#1D293D' : '#F8FAFC';
  const mainBg = isDark ? '#0F172B' : '#FFFFFF';
  const mainShadow = isDark ? '0px 1px 2px rgba(2, 6, 24, 0.5)' : '0px 1px 2px rgba(43, 127, 255, 0.1)';
  const headerBorder = isDark ? '#1D293D' : '#F1F5F9';
  const titleColor = isDark ? '#E2E8F0' : '#314158';

  return (
    <div
      className="flex flex-col items-start flex-1 min-h-0 font-geist p-0 lg:pt-2 lg:pr-2 lg:pb-2 lg:pl-0"
      style={{ gap: '8px', background: containerBg }}
    >
      <div
        className="flex flex-col items-start flex-1 min-h-0 w-full overflow-hidden rounded-none lg:rounded-2xl"
        style={{ background: mainBg, boxShadow: mainShadow }}
      >
        {/* Header 84px */}
        <div
          className="flex flex-col justify-center items-start w-full flex-shrink-0 rounded-none lg:rounded-t-2xl"
          style={{ padding: '12px 16px', borderBottom: `1px solid ${headerBorder}` }}
        >
          <div className="flex flex-row items-center w-full" style={{ gap: '8px' }}>
            {/* Hamburger menu for mobile */}
            <button
              className="lg:hidden flex items-center justify-start flex-shrink-0"
              style={{ width: '24px', height: '36px', background: 'transparent', border: 'none', cursor: 'pointer', padding: 0 }}
              onClick={toggleSidebar}
            >
              <Menu size={24} color={isDark ? '#E2E8F0' : '#314158'} />
            </button>
            <div
              className="hidden lg:flex"
              style={{
                width: '36px',
                height: '36px',
                background: isDark ? '#1C398E' : '#EFF6FF',
                borderRadius: '12px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Shield size={20} style={{ color: isDark ? '#51A2FF' : '#2B7FFF' }} />
            </div>
            <h1
              style={{
                fontFamily: 'Geist, sans-serif',
                fontSize: '20px',
                lineHeight: '28px',
                fontWeight: 700,
                color: titleColor,
                margin: 0,
                flex: 1,
              }}
            >
              Proxy Management
            </h1>
          </div>
        </div>

        {/* Scrollable content */}
        <div
          className={`overflow-y-auto w-full ${isDark ? 'scrollbar-themed-dark' : 'scrollbar-themed-light'}`}
          style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, minHeight: 0 }}
        >
          <ProxiesManager />
        </div>
      </div>
    </div>
  );
};

export default ProxiesManagement;
